import { render } from "./UpdatePost.vue?vue&type=template&id=b8669854&ts=true"
import script from "./UpdatePost.vue?vue&type=script&lang=ts"
export * from "./UpdatePost.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__